import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import PageWrapper from '../../components/PageWrapper'
import { ImportAudienceForm } from './form'

import './styles.css'
import { Preloader } from '../../components/Chart/index'
import axios from 'axios'

class ImportAudience extends Component {
    constructor(props) {
        super(props)

        let search = window.location.search
        let params = new URLSearchParams(search)
        console.log('import query params', window.location.search)
        console.log('import query params', params, params.get('audienceId'))

        this.state = {
            saving: false,
            //audienceName: '',
            //description: '',
            //branded: true,
            audience_prefix: '',
            //importBtn: false,
            audienceId: params.get('audienceId'),
            audienceName: params.get('audienceName'),
            description: params.get('description'),
            branded: params.get('branded') == 'true',
            importBtn: params.get('importBtn') == 'true'
        }
    }

    save({ audienceName, description, branded, csvFile, audienceId, uploadNotificationData }) {
        this.setState({ saving: true })
        console.log('SAVE::audienceId: ', audienceId)
        console.log('SAVE::name: ', audienceName)
        console.log('SAVE::descr: ', description)
        console.log('SAVE::uploadNotificationData: ', uploadNotificationData)

        // call upload notification on create
        console.log('csvFile:', csvFile)
        console.log('uploadNotificationData:', uploadNotificationData)
        if (csvFile && csvFile != '' && uploadNotificationData) {
            //console.log('save audience response ', response)
            //uploadNotificationData.audienceId = response.body.audienceId
            uploadNotificationData.audienceId = audienceId
            // confirm promise after upload notification
            axios
                .post('/upload_notification', uploadNotificationData)
                .then(response => {
                    console.log('calling upload notification response', response)
                    // TODO: handle errors

                    this.setState({ saving: false })
                    this.props.goBack()
                })
                .catch(error => {
                    // handle error
                    console.log('upload notification error: ', error)
                    this.setState({ saving: false })
                })
        } else {
            this.setState({ saving: false })
            this.props.goBack()
        }
    }

    render() {
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <ImportAudienceForm
                        uploadType="single"
                        audienceId={this.state.audienceId}
                        audienceName={this.state.audienceName}
                        description={this.state.description}
                        branded={this.state.branded}
                        importBtn={this.state.importBtn}
                        cancel={() => this.props.goBack()}
                        save={formState => this.save(formState)}
                    />

                    {this.state.saving && <Preloader transparent />}
                </div>
            </PageWrapper>
        )
    }
}

export default connect(
    state => ({}),
    {
        goBack: () => push('/audiences')
    }
)(ImportAudience)
